import { useRef, useEffect } from 'react';
import { IArkComponent } from '@apps/i-ark';
import { useScrollIntoViewOnNavigation } from '@pm2/react-utils';
import { useComponentFrameworkAutoDeactivation, componentFrameworkStore } from '@provider/component-framework';
import { useLocation } from '@provider/navigation';
import { useClickOutsideListener } from '@utils/react';
import { contentTransitionDurationMs } from './comp.router.style.js';
import { jsx } from 'react/jsx-runtime';

function EmbedContent(props) {
  const ref = useRef(null);
  const contentRef = useRef(null);
  const isTransitioningBetweenPagesRef = useTransitionState();
  useScrollIntoViewOnNavigation(contentRef, {
    offsetPx: -60
  });
  useComponentFrameworkAutoDeactivation(props.rootRef, {
    componentId: props.node.component.envelope.ID,
    isDisabledRef: isTransitioningBetweenPagesRef,
    onDeactivate: props.onDeactivate
  });
  useClickOutsideListener(() => {
    componentFrameworkStore.dispatch(componentFrameworkStore.actions.deactivateComponent(props.node.component.envelope.ID));
    props.onDeactivate();
  }, ref);
  return /*#__PURE__*/jsx(IArkComponent, {
    ref: ref,
    contentRef: contentRef,
    context: "embedded",
    onActivate: props.onActivate,
    onShareWithTeacher: props.onShareWithTeacher,
    onCollapse: props.onCollapse,
    openInLightbox: props.onOpenInLightbox,
    onMountedInFullscreen: props.onMountedInFullscreen,
    node: props.node
  });
}
function useTransitionState() {
  const location = useLocation();
  const isTransitioningRef = useRef(false);
  useEffect(() => {
    isTransitioningRef.current = true;
    const timeoutId = setTimeout(() => {
      isTransitioningRef.current = false;
    }, contentTransitionDurationMs);
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [location.asPath]);
  return isTransitioningRef;
}

export { EmbedContent };
//# sourceMappingURL=comp.embed-integration.js.map
